// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"23cda0b4","158":"8e89a436","168":"1f19c9b5","174":"2ae22a7f","336":"a7c26300","370":"83809794","379":"b469fe08","400":"f0eb14aa","442":"06e962c1","753":"4ef003a4","821":"a688b25a","871":"7806b406","975":"5f866e46"}[chunkId] + ".chunk.js";
};